import withToggle from '../../hoc/withToggle';

const ColorPickerContainer = withToggle();

export default ColorPickerContainer;
